export default "__VITE_ASSET__6b5ccf81__"